import { render } from "./MarkinAttendance.vue?vue&type=template&id=65324dfa&scoped=true"
import script from "./MarkinAttendance.vue?vue&type=script&lang=js"
export * from "./MarkinAttendance.vue?vue&type=script&lang=js"

import "./MarkinAttendance.vue?vue&type=style&index=0&id=65324dfa&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65324dfa"]])

export default __exports__